import { __decorate } from 'tslib';
import { Injectable, Component, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { routerReducer, StoreRouterConnectingModule } from '@ngrx/router-store';
import { createFeatureSelector, createSelector, Store, StoreModule } from '@ngrx/store';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@ngrx/store';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from '@ngrx/router-store';
const ROUTER_FEATURE_KEY = 'router';

let SSRouterSerializer = class SSRouterSerializer {
    serialize(routerState) {
        return {
            url: routerState.url,
            params: searchRouterStateTree(routerState.root, r => r.params),
            queryParams: routerState.root.queryParams,
            fragment: routerState.root.fragment,
            data: searchRouterStateTree(routerState.root, r => r.data)
        };
    }
};
SSRouterSerializer.ɵfac = function SSRouterSerializer_Factory(t) { return new (t || SSRouterSerializer)(); };
SSRouterSerializer.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: SSRouterSerializer, factory: SSRouterSerializer.ɵfac });
function searchRouterStateTree(route, getter) {
    if (route.children.length === 0) {
        return getter(route);
    }
    return route.children.reduce((obj, childRoute) => (Object.assign(Object.assign(Object.assign({}, obj), getter(route)), searchRouterStateTree(childRoute, getter))), {});
}

const getRouterState = createFeatureSelector(ROUTER_FEATURE_KEY);
const ɵ0 = routerState => routerState.state;
const getRouteMap = createSelector(getRouterState, ɵ0);
const ɵ1 = routerState => routerState.navigationId;
const getNavigationId = createSelector(getRouterState, ɵ1);
const ɵ2 = routerState => routerState.state.url;
const getURL = createSelector(getRouterState, ɵ2);
const ɵ3 = routerState => routerState.state.params;
const getParams = createSelector(getRouterState, ɵ3);
const ɵ4 = routerState => routerState.state.queryParams;
const getQueryParams = createSelector(getRouterState, ɵ4);
const ɵ5 = routerState => routerState.state.fragment;
const getFragment = createSelector(getRouterState, ɵ5);
const ɵ6 = routerState => routerState.state.data;
const getData = createSelector(getRouterState, ɵ6);

let SsNgrxRouterStoreStateComponent = class SsNgrxRouterStoreStateComponent {
    constructor(store) {
        this.store = store;
    }
    ngOnInit() {
        this.routerState$ = this.store.select(getRouterState);
    }
};
SsNgrxRouterStoreStateComponent.ɵfac = function SsNgrxRouterStoreStateComponent_Factory(t) { return new (t || SsNgrxRouterStoreStateComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.Store)); };
SsNgrxRouterStoreStateComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SsNgrxRouterStoreStateComponent, selectors: [["ss-ngrx-router-store-state"]], decls: 4, vars: 5, consts: [[1, "container"]], template: function SsNgrxRouterStoreStateComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "pre", 0);
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵpipe(2, "json");
        ɵngcc0.ɵɵpipe(3, "async");
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1("      ", ɵngcc0.ɵɵpipeBind1(2, 1, ɵngcc0.ɵɵpipeBind1(3, 3, ctx.routerState$)), "\n    ");
    } }, pipes: [ɵngcc2.JsonPipe, ɵngcc2.AsyncPipe], styles: [".container[_ngcontent-%COMP%] {\n        font-size: large;\n      }"] });
SsNgrxRouterStoreStateComponent.ctorParameters = () => [
    { type: Store }
];

const routerConfig = {
    stateKey: ROUTER_FEATURE_KEY,
    serializer: SSRouterSerializer
};
let SSNgRxRouterStoreModule = class SSNgRxRouterStoreModule {
};
SSNgRxRouterStoreModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: SSNgRxRouterStoreModule });
SSNgRxRouterStoreModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function SSNgRxRouterStoreModule_Factory(t) { return new (t || SSNgRxRouterStoreModule)(); }, imports: [[
            CommonModule,
            StoreModule.forFeature(ROUTER_FEATURE_KEY, routerReducer),
            StoreRouterConnectingModule.forRoot(routerConfig)
        ]] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SSRouterSerializer, [{
        type: Injectable
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SsNgrxRouterStoreStateComponent, [{
        type: Component,
        args: [{
                selector: 'ss-ngrx-router-store-state',
                template: `
    <pre class="container">
      {{ routerState$ | async | json }}
    </pre
    >
  `,
                styles: [`
      .container {
        font-size: large;
      }
    `]
            }]
    }], function () { return [{ type: ɵngcc1.Store }]; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SSNgRxRouterStoreModule, { declarations: function () { return [SsNgrxRouterStoreStateComponent]; }, imports: function () { return [CommonModule, ɵngcc1.StoreFeatureModule, ɵngcc3.StoreRouterConnectingModule]; }, exports: function () { return [SsNgrxRouterStoreStateComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SSNgRxRouterStoreModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    StoreModule.forFeature(ROUTER_FEATURE_KEY, routerReducer),
                    StoreRouterConnectingModule.forRoot(routerConfig)
                ],
                declarations: [SsNgrxRouterStoreStateComponent],
                exports: [SsNgrxRouterStoreStateComponent]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { SSNgRxRouterStoreModule, SSRouterSerializer, getData, getFragment, getNavigationId, getParams, getQueryParams, getRouteMap, getRouterState, getURL, ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ROUTER_FEATURE_KEY as ɵa, SsNgrxRouterStoreStateComponent as ɵb };

//# sourceMappingURL=ss-ngrx-router-store.js.map